import { createFileRoute, redirect } from '@tanstack/react-router';

import { conversationDetailsQueryOptions } from '@/api/endpoints/conversations';
import { ConversationLoading } from '@/components/features/conversation/history/ConversationLoading';
import { ConversationStoreProvider } from '@/components/features/conversation/providers/ConversationStoreProvider';
import { ConversationLoadingError } from '@/components/features/conversation/types';
import { UnifiedChatContent } from '@/components/features/conversation/UnifiedChatContent';
import { safeInvoke } from '@/utils/safe-invoke';

export const Route = createFileRoute('/_protected/t/$tenantId/conversation/$conversationId')({
  loader: async ({ context: { queryClient }, params: { conversationId, tenantId } }) => {
    const { data, error } = await safeInvoke(
      queryClient.ensureQueryData(conversationDetailsQueryOptions({ conversation_id: conversationId })),
    );

    if (error) {
      throw redirect({
        to: '/t/$tenantId/conversation/new',
        params: { tenantId },
        search: { error: ConversationLoadingError.NOT_FOUND },
      });
    }

    return {
      messages: data.history,
      attachments: data.files,
      lastUpdated: data.serverTime,
      chatType: data.conversation_type,
    };
  },
  pendingComponent: () => <ConversationLoading />,
  component: ConversationPage,
});

function ConversationPage() {
  const { conversationId } = Route.useParams();
  const { messages, attachments, lastUpdated, chatType } = Route.useLoaderData();

  return (
    <ConversationStoreProvider
      key={conversationId}
      initialState={{
        conversationId,
        messages,
        attachments,
        lastUpdated,
        isPersistedConversation: true,
        ...(chatType ? { chatType } : {}),
      }}
    >
      <UnifiedChatContent />
    </ConversationStoreProvider>
  );
}
